import { render } from "./form-generator.vue?vue&type=template&id=0a93a4fa"
import script from "./form-generator.vue?vue&type=script&lang=js"
export * from "./form-generator.vue?vue&type=script&lang=js"

import "./form-generator.vue?vue&type=style&index=0&id=0a93a4fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__